<template>
  <div class="client-table-wrapper">
    <!-- Tableau Vuetify -->
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      :loading="loading"
      :items-per-page="itemsPerPage"
      :page="page"
      v-model:items-per-page="itemsPerPage"
      v-model:page="page"
      v-model:sort-by="sortBy"
      show-select
      v-model="selectedTiers"
      item-key="gp_tiers"
      class="elevation-1"
      :custom-filter="customFilter"
    >
      <!-- En-tête personnalisé avec filtres -->
      <template #top>
        <!-- Barre d'outils avec bouton stats -->
        <v-toolbar density="comfortable" class="px-3">
          <v-toolbar-title>Clients</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="selectedTiers.length === 0"
            @click="handleStatsClick"
            icon
            variant="flat"
            size="small"
            title="Voir les statistiques"
          >
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Barre de filtres -->
        <v-card variant="outlined" class="mx-3 mb-3">
          <v-card-text class="pa-2">
            <v-row dense>
              <v-col cols="auto" class="d-flex align-center">
                <v-checkbox
                  v-model="selectAll"
                  @update:model-value="handleSelectAll"
                  hide-details
                  density="compact"
                ></v-checkbox>
              </v-col>
              
              <v-col cols="2">
                <v-text-field
                  v-model="filters.t_tiers"
                  label="Cde Client"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="2">
                <v-text-field
                  v-model="filters.t_libelle"
                  label="Nom"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="2">
                <v-text-field
                  v-model="filters.t_prenom"
                  label="Prénom"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="1">
                <v-text-field
                  v-model="filters.t_sexe"
                  label="Genre"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="1">
                <v-text-field
                  v-model="filters.age"
                  label="Âge"
                  type="number"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="2">
                <v-text-field
                  v-model="filters.t_telephone"
                  label="Téléphone"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="2">
                <v-text-field
                  v-model="filters.t_email"
                  label="Email"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
            </v-row>
            
            <v-row dense>
              <v-col cols="auto"></v-col>
              <v-col cols="1">
                <v-text-field
                  v-model="filters.t_codepostal"
                  label="Code Postal"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="1">
                <v-text-field
                  v-model="filters.t_etablissement"
                  label="Ratach"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="1">
                <v-text-field
                  v-model="filters.nbrpassages"
                  label="Nb.pass"
                  type="number"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
              
              <v-col cols="1">
                <v-text-field
                  v-model="filters.gl_etablissement"
                  label="Etab"
                  density="compact"
                  hide-details
                  variant="outlined"
                  @update:model-value="applyFilters"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>

      <!-- Corps du tableau -->
      <template #item="{ item, isSelected, toggleSelect }">
        <!-- Ligne principale -->
        <tr :class="{ 'selected-row': isSelected }">
          <!-- Case à cocher -->
          <td>
            <v-checkbox
              :model-value="isSelected"
              @update:model-value="toggleSelect"
              @change="handleTierSelection(item, $event)"
              hide-details
              density="compact"
            ></v-checkbox>
          </td>

          <!-- Cde Client - cliquable -->
          <td>
            <v-btn
              variant="text"
              color="primary"
              @click="handleClientCodeClick(item.gp_tiers)"
              class="text-left px-0"
              style="min-width: 0; text-transform: none; font-weight: normal;"
              size="small"
            >
              {{ item.gp_tiers }}
            </v-btn>
          </td>

          <!-- Nom - cliquable -->
          <td>
            <v-btn
              variant="text"
              color="primary"
              @click="handleClientNameClick(item.gp_tiers)"
              class="text-left px-0"
              style="min-width: 0; text-transform: none; font-weight: normal;"
              size="small"
            >
              <span class="text-truncate" style="max-width: 140px; display: inline-block;">
                {{ item.t_libelle }}
              </span>
            </v-btn>
          </td>

          <!-- Prénom -->
          <td>{{ item.t_prenom }}</td>

          <!-- Genre -->
          <td>{{ item.t_sexe }}</td>

          <!-- Âge -->
          <td>{{ calculateAge(item.t_anneenaissance) }}</td>

          <!-- Téléphone -->
          <td>{{ item.t_telephone }}</td>

          <!-- Email -->
          <td class="text-truncate" style="max-width: 150px;">
            {{ item.t_email }}
          </td>

          <!-- Code Postal -->
          <td>{{ item.t_codepostal }}</td>

          <!-- Ratach -->
          <td>{{ item.t_etablissement }}</td>

          <!-- Nb.pass -->
          <td>{{ item.nbrpassages }}</td>

          <!-- D.Création -->
          <td>{{ formatDate(item.t_datecreation) }}</td>

          <!-- D.Modif -->
          <td>{{ formatDate(item.t_datemodif) }}</td>

          <!-- Etab - Bouton pour afficher les détails -->
          <td>
            <v-btn
              v-if="hasEtabDetails(item)"
              icon
              size="small"
              variant="text"
              @click="toggleEtabDetails(item)"
              :color="item.showEtabDetails ? 'primary' : undefined"
            >
              <v-icon>{{ item.showEtabDetails ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
            </v-btn>
            <span v-else>-</span>
          </td>

          <!-- Prem.ACHAT -->
          <td>{{ formatDate(item.premiere_vente_global) }}</td>

          <!-- Dern.Achat -->
          <td>{{ formatDate(item.derniere_vente_global) }}</td>

          <!-- Nbre -->
          <td>{{ calculateTotalQte(item) }}</td>

          <!-- TOT TTC -->
          <td class="font-weight-medium text-right">
            € {{ calculateTotalTTC(item).toFixed(2) }}
          </td>
        </tr>

        <!-- Ligne des établissements (expandable) -->
        <tr v-if="item.showEtabDetails && hasEtabDetails(item)">
          <td :colspan="headers.length" class="pa-0 bg-grey-lighten-4">
            <v-table density="compact" class="elevation-0">
              <thead>
                <tr class="bg-grey-lighten-3">
                  <th width="50px">Etab</th>
                  <th width="70px">Prem.ACHAT</th>
                  <th width="70px">Dern.Achat</th>
                  <th width="50px">Nbre</th>
                  <th width="100px">TOT TTC</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="etab in getEtabDetails(item.t_tiers)" :key="etab.gl_etablissement">
                  <td width="50px">{{ etab.gl_etablissement }}</td>
                  <td width="70px">{{ formatDate(etab.premiere_vente_etablissement) }}</td>
                  <td width="70px">{{ formatDate(etab.derniere_vente_etablissement) }}</td>
                  <td width="50px">{{ etab.nb_ventes_etablissement }}</td>
                  <td width="100px" class="font-weight-medium text-right">
                    € {{ formatCurrency(etab.total_ttc_etablissement) }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </td>
        </tr>
      </template>

      <!-- Pas de données -->
      <template #no-data>
        <v-alert type="info" class="ma-4">
          Aucun client trouvé
        </v-alert>
      </template>

      <!-- Pagination personnalisée -->
      <template #bottom>
        <div class="d-flex align-center pa-3">
          <span class="text-caption text-medium-emphasis">
            {{ selectedTiers.length }} sélectionné(s) sur {{ filteredItems.length }} client(s)
          </span>
          <v-spacer></v-spacer>
          <v-select
            v-model="itemsPerPage"
            :items="[10, 20, 50, 100]"
            density="compact"
            variant="outlined"
            hide-details
            style="max-width: 100px;"
            label="Par page"
          ></v-select>
          <v-pagination
            v-model="page"
            :length="Math.ceil(filteredItems.length / itemsPerPage)"
            total-visible="5"
            density="comfortable"
            class="ml-4"
          ></v-pagination>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'

// Props
const props = defineProps({
  statsTableFiltred: {
    type: Array,
    required: true,
    default: () => []
  },
  stats: {
    type: Object,
    required: true,
    default: () => ({})
  },
  filtreSingleParams: {
    type: Object,
    required: true,
    default: () => ({ gp_tiers: [] })
  }
})

// Événements
const emit = defineEmits([
  'getStatsTiers',
  'getClients',
  'addTiers',
  'checkTiers',
  'setVisible'
])

// États réactifs
const search = ref('')
const selectAll = ref(false)
const selectedTiers = ref([])
const itemsPerPage = ref(20)
const page = ref(1)
const sortBy = ref([])
const loading = ref(false)
const expandedRows = ref([])

// Filtres
const filters = ref({
  t_tiers: '',
  t_libelle: '',
  t_prenom: '',
  t_sexe: '',
  age: '',
  t_telephone: '',
  t_email: '',
  t_codepostal: '',
  t_etablissement: '',
  nbrpassages: '',
  gl_etablissement: ''
})

// Headers du tableau
const headers = [
  { title: '', key: 'data-table-select', sortable: false, width: '50px' },
  { title: 'Cde Client', key: 'gp_tiers', width: '120px', sortable: true },
  { title: 'Nom', key: 't_libelle', width: '150px', sortable: true },
  { title: 'Prénom', key: 't_prenom', width: '100px', sortable: true },
  { title: 'Genre', key: 't_sexe', width: '50px', sortable: true },
  { title: 'Âge', key: 't_anneenaissance', width: '50px', sortable: true },
  { title: 'Tel', key: 't_telephone', width: '100px', sortable: true },
  { title: 'email', key: 't_email', width: '150px', sortable: true },
  { title: 'code Postal', key: 't_codepostal', width: '70px', sortable: true },
  { title: 'Ratach', key: 't_etablissement', width: '50px', sortable: true },
  { title: 'Nb.pass', key: 'nbrpassages', width: '50px', sortable: true },
  { title: 'D.Création', key: 't_datecreation', width: '70px', sortable: true },
  { title: 'D.Modif', key: 't_datemodif', width: '70px', sortable: true },
  { title: 'Etab', key: 'etab', width: '50px', sortable: false },
  { title: 'Prem.ACHAT', key: 'premiere_vente_global', width: '70px', sortable: true },
  { title: 'Dern.Achat', key: 'derniere_vente_global', width: '70px', sortable: true },
  { title: 'Nbre', key: 'nbre', width: '50px', sortable: false },
  { title: 'TOT TTC', key: 'total_ttc', width: '100px', sortable: false }
]

// Items filtrés
const filteredItems = computed(() => {
  const items = props.statsTableFiltred.map(item => ({
    ...item,
    showEtabDetails: expandedRows.value.includes(item.gp_tiers)
  }))
  
  return items.filter(item => {
    // Filtrage par tous les champs
    for (const [key, value] of Object.entries(filters.value)) {
      if (value && value.toString().trim() !== '') {
        const itemValue = item[key]?.toString().toLowerCase() || ''
        const filterValue = value.toString().toLowerCase()
        
        // Traitement spécial pour l'âge
        if (key === 'age') {
          const age = calculateAge(item.t_anneenaissance)
          if (age !== parseInt(value)) return false
          continue
        }
        
        // Filtre normal
        if (!itemValue.includes(filterValue)) return false
      }
    }
    
    // Filtre de recherche globale
    if (search.value) {
      const searchLower = search.value.toLowerCase()
      const searchableFields = [
        item.gp_tiers,
        item.t_libelle,
        item.t_prenom,
        item.t_email,
        item.t_telephone
      ]
      
      return searchableFields.some(field => 
        field && field.toLowerCase().includes(searchLower)
      )
    }
    
    return true
  })
})

// Méthodes
const handleStatsClick = () => {
  if (selectedTiers.value.length > 0) {
    emit('getStatsTiers', 'search_ventes')
  }
}

const handleSelectAll = (checked) => {
  emit('checkTiers', checked)
  if (checked) {
    selectedTiers.value = [...filteredItems.value]
  } else {
    selectedTiers.value = []
  }
}

const handleTierSelection = (tier, checked) => {
  emit('addTiers', tier.gp_tiers, checked)
}

const handleClientCodeClick = (tiersCode) => {
  emit('getStatsTiers', 'search_ventes', tiersCode)
  emit('getClients', tiersCode)
}

const handleClientNameClick = (tiersCode) => {
  emit('getClients', tiersCode)
}

const toggleEtabDetails = (item) => {
  const index = expandedRows.value.indexOf(item.gp_tiers)
  if (index > -1) {
    expandedRows.value.splice(index, 1)
    item.showEtabDetails = false
  } else {
    expandedRows.value.push(item.gp_tiers)
    item.showEtabDetails = true
    // Charger les détails si nécessaire
    if (!hasEtabDetails(item)) {
      emit('setVisible', item, 'allstats')
    }
  }
}

const hasEtabDetails = (item) => {
  return props.stats[item.t_tiers] && 
         Object.values(props.stats[item.t_tiers]).some(etab => etab && etab.visible)
}

const getEtabDetails = (tiersCode) => {
  const tiersStats = props.stats[tiersCode]
  if (!tiersStats) return []
  
  return Object.values(tiersStats).filter(etab => 
    etab && etab.visible
  )
}

const calculateAge = (anneeNaissance) => {
  if (!anneeNaissance || anneeNaissance === '1900') return ''
  return new Date().getFullYear() - parseInt(anneeNaissance)
}

const formatDate = (dateString) => {
  if (!dateString) return ''
  return dateString.split('T')[0]
}

const formatCurrency = (value) => {
  const num = parseFloat(value || 0)
  return num.toFixed(2)
}

const calculateTotalQte = (item) => {
  // Logique de calcul du total des quantités
  // À adapter selon votre structure de données
  return item.totalQte || 0
}

const calculateTotalTTC = (item) => {
  // Logique de calcul du total TTC
  // À adapter selon votre structure de données
  return parseFloat(item.totalTTC || 0)
}

const applyFilters = () => {
  // Réinitialiser la page lors du filtrage
  page.value = 1
}

const customFilter = (value, query, item) => {
  // Filtre personnalisé pour la recherche globale
  if (!query) return true
  
  const searchLower = query.toLowerCase()
  const searchFields = [
    item.gp_tiers,
    item.t_libelle,
    item.t_prenom,
    item.t_email,
    item.t_telephone,
    item.t_codepostal
  ]
  
  return searchFields.some(field => 
    field && field.toString().toLowerCase().includes(searchLower)
  )
}

// Watchers
watch(selectedTiers, (newVal) => {
  selectAll.value = newVal.length === filteredItems.value.length && filteredItems.value.length > 0
})

watch(filters, () => {
  applyFilters()
}, { deep: true })
</script>

<style scoped>
.client-table-wrapper {
  overflow-x: auto;
}

.selected-row {
  background-color: rgba(25, 118, 210, 0.04);
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .v-data-table__wrapper {
  min-height: 400px;
}

::v-deep .v-data-table td {
  white-space: nowrap;
}

::v-deep .v-btn--variant-text.v-btn--density-compact {
  min-height: 24px;
  padding: 0 4px;
}

::v-deep .v-checkbox {
  margin: 0;
  padding: 0;
}
</style>